import { render } from "./CashacFees.vue?vue&type=template&id=70a834cc&scoped=true&ts=true"
import script from "./CashacFees.vue?vue&type=script&lang=ts"
export * from "./CashacFees.vue?vue&type=script&lang=ts"

import "./CashacFees.vue?vue&type=style&index=0&id=70a834cc&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a834cc"]])

export default __exports__